import { JSONValidator } from '@components/Inputs';
import { useEffect } from 'react';

const ColourSetForm = ({ parameter, isViewMode, onCallbackChange }) => {
  const colourSet = parameter.value?.colourSet;

  const defaultColourSet = {
    primary: '#201b50',
    secondary: '#077bc0',
  };

  useEffect(() => {
    if (!colourSet) {
      setTimeout(() => {
        onCallbackChange('value.colourSet')(defaultColourSet);
      }, 1000);
    }
  }, []);

  return (
    <JSONValidator
      label={'Colour set'}
      value={colourSet}
      disabled={isViewMode}
      placeholder={defaultColourSet}
      onJSONValidated={onCallbackChange('value.colourSet')}
    />
  );
};

export default ColourSetForm;
